import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import { Button, Typography, CircularProgress } from '@material-ui/core';
import ArrowForward from '@material-ui/icons/ArrowForward';
import MailOutline from '@material-ui/icons/MailOutline';
import VpnKeyOutlined from '@material-ui/icons/VpnKeyOutlined';
import LockOutlined from '@material-ui/icons/LockOutlined';
import Timer from '@material-ui/icons/Timer';
import CheckRounded from '@material-ui/icons/CheckRounded';
import { PGService } from '../../Remote/PowerGym';
import { showSnackbar } from '../../Redux/actions/snackbar';
import { startAccountLink } from './asLinkFlow';
import logo from '../App/Sidebar/logo.png';
import './LinkAccount.css';

/**
 * Pantalla bloqueante de la ventana de mudanza: la app exige crear la cuenta nueva de PowerGym
 * (email verificado) antes de seguir. Se muestra cuando `as_link.required` y el socio no está
 * vinculado. Carga el perfil una vez si el store todavía no lo tiene.
 */
class LinkAccountGate extends Component {
    state = { starting: false };

    componentDidMount() {
        if (!this.props.asLink.loaded) {
            PGService.profile();
        }
    }

    start = async () => {
        this.setState({ starting: true });
        const result = await startAccountLink();
        if (!result.ok) {
            this.setState({ starting: false });
            this.props.showSnackbar(result.message || this.props.t('as_link_start_error'));
        }
    };

    render() {
        const { t, asLink, children, instance } = this.props;
        const { starting } = this.state;

        if (!asLink.loaded) {
            return (
                <div className="asLinkLoading">
                    <CircularProgress />
                </div>
            );
        }

        const data = asLink.data;
        const mustLink = Boolean(data && data.enabled && data.required && data.status !== 'linked');
        if (!mustLink) {
            return children;
        }

        const gym = (instance && instance.name) || t('as_link_gym_fallback');
        const steps = [
            { icon: <MailOutline />, label: t('as_link_step_email') },
            { icon: <VpnKeyOutlined />, label: t('as_link_step_code') },
            { icon: <LockOutlined />, label: t('as_link_step_password') },
        ];

        return (
            <div className="asLinkGate">
                <section className="asLinkCard" aria-labelledby="asLinkTitle">
                    <header className="asLinkHero">
                        <div className="asLinkBrandRow">
                            <img src={logo} alt="PowerGym" className="asLinkBrand" />
                            <span className="asLinkChip">{t('as_link_chip')}</span>
                        </div>
                        <Typography component="h1" id="asLinkTitle" className="asLinkTitle">
                            {t('as_link_title')}
                        </Typography>
                        <Typography component="p" className="asLinkLead">
                            {t('as_link_intro', { gym })}
                        </Typography>
                    </header>

                    <ol className="asLinkSteps">
                        {steps.map((step, i) => (
                            <li key={i} className="asLinkStep">
                                <span className="asLinkStepIcon" aria-hidden="true">{step.icon}</span>
                                <span className="asLinkStepText">{step.label}</span>
                                <span className="asLinkStepNum" aria-hidden="true">{i + 1}</span>
                            </li>
                        ))}
                    </ol>

                    <div className="asLinkMeta">
                        <span className="asLinkMetaItem"><Timer /> {t('as_link_meta_time')}</span>
                        <span className="asLinkMetaItem"><CheckRounded /> {t('as_link_meta_prefilled')}</span>
                    </div>

                    <div className="asLinkActions">
                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            size="large"
                            onClick={this.start}
                            disabled={starting}
                            className="asLinkButton"
                        >
                            {starting ? t('as_link_starting') : t('as_link_cta')}
                            {!starting && <ArrowForward className="asLinkButtonIcon" />}
                        </Button>
                        <Typography component="p" className="asLinkHint">
                            {t('as_link_already_hint')}
                        </Typography>
                    </div>
                </section>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    asLink: state.asLink,
    instance: state.instance.data,
});

const mapDispatchToProps = (dispatch) => ({
    showSnackbar: (message) => dispatch(showSnackbar(message)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(LinkAccountGate));
